import { StoreAction, XmAction } from 'store/actions';
import { LineLockStatus } from './models';

export function mdnLineLockStatusReducer(state: LineLockStatus, action: XmAction<LineLockStatus>): LineLockStatus {
    switch (action.type) {
        case StoreAction.GET_LINE_LOCK_STATUS:
            return action.payload;
        default:
            return state;
    }
}
